import { Button, DateTime, Level, SearchInput, Table } from '~/components';
import { TableBoxRowActions } from '~/components/table';
import { useApi } from '~/contexts';
import { useDocumentTitle } from '~/hooks';
import React, { useCallback, useEffect, useState } from 'react';
import { ErrorPage, PageLoader } from '~/routes/public/pages';
import ProductUpdateDrawer from './ProductUpdateDrawer';
import styled from 'styled-components';
import { useHistory } from 'react-router';

const PageArea = styled.div`
  display: flex;
  flex-direction: column;
`;

function ProductUpdatesList() {
  const documentTitle = useDocumentTitle("What's New");

  const api = useApi();
  const history = useHistory();

  const [query, setQuery] = useState({ isReady: false, data: null, error: null });
  const [params, setParams] = useState({ q: '' });

  const fetchData = useCallback(async () => {
    try {
      const { data } = await api.admin.productUpdates.get(params);
      setQuery({ isReady: true, data });
    } catch (error) {
      setQuery({ isReady: true, data: null, error });
    }
  }, [params, api]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const [dialog, setDialog] = useState(null);

  const handleFilterChange = ({ target: { name, value } }) => {
    setParams((state) => ({ ...state, [name]: value }));
  };

  const handleEdit = async (entry) => {
    setDialog(
      <ProductUpdateDrawer
        entry={entry}
        onClose={() => {
          setDialog(null);
          documentTitle.set("What's New");
        }}
        onDeleted={fetchData}
        onSaved={fetchData}
      />,
    );
  };

  if (!query.isReady) return <PageLoader />;
  if (!query.data) return <ErrorPage publicSite={false} />;

  const data = query.data;

  return (
    <PageArea>
      <Level>
        <Level.Item>
          <SearchInput
            value={params.q}
            placeholder="Search"
            materialPlaceholder="Title"
            materialAlwaysVisible
            onChange={handleFilterChange}
          />
        </Level.Item>
        <Level.Item width="5rem" right>
          <Button onClick={() => history.push({ pathname: '/whats-new' })}>Go to What's New</Button>
        </Level.Item>
        <Level.Item width="5rem" right>
          <Button onClick={() => handleEdit({})}>New Entry</Button>
        </Level.Item>
      </Level>
      <Table.Total value={data.length} label="Entry" style={{ marginTop: '1rem' }} />
      <Table>
        <Table.BoxHeader>
          <Table.Column>Date</Table.Column>
          <Table.Column>Title</Table.Column>
          <Table.Column>Audience</Table.Column>
          <Table.Column align="right">Promoted</Table.Column>
          <Table.Column align="right">Published</Table.Column>
          <Table.BoxActionsColumn />
        </Table.BoxHeader>
        <Table.Body>
          {data.map((entry) => {
            const { date, title, audience, isPromoted, isPublished, id } = entry;

            return (
              <Table.BoxRow onClick={() => handleEdit(entry)} key={id}>
                <Table.Cell>
                  <DateTime value={date} />
                </Table.Cell>
                <Table.Cell>{title}</Table.Cell>
                <Table.Cell>{{ members: 'All Members', admins: 'Workspace Admins' }[audience]}</Table.Cell>
                <Table.Cell>{isPromoted ? 'Promoted' : 'Not Promoted'}</Table.Cell>
                <Table.Cell>{isPublished ? 'Published' : 'Not Published'}</Table.Cell>

                <TableBoxRowActions>
                  <TableBoxRowActions.Edit onClick={() => handleEdit(entry)} />
                </TableBoxRowActions>
              </Table.BoxRow>
            );
          })}
        </Table.Body>
      </Table>

      {dialog}
    </PageArea>
  );
}

export default ProductUpdatesList;
